// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vss-FilterBar {
  display: flex;
  flex-shrink: 1;
  background: rgba(0, 0, 0, 0.06);
  background: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
  padding: 8px;
  border-radius: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}
@media (forced-colors: active) {
  .vss-FilterBar {
    border: 1px solid windowtext;
  }
}
.vss-FilterBar .filter-bar-button {
  padding-left: 8px;
  padding-right: 8px;
}
.vss-FilterBar .filter-bar-button.disabled {
  background-color: transparent;
}
.vss-FilterBar .vss-FilterBar--list {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding-left: 0;
  width: 100%;
}
.vss-FilterBar .vss-FilterBar--list.justify-right {
  justify-content: flex-end;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item {
  flex-shrink: 0;
  max-width: 100%;
}
@media screen and (max-width: 599px) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item {
    max-width: 130px;
  }
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .bolt-textfield {
  background-color: transparent;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.max-width-small .vss-PickListDropdown--title .vss-PickListDropdown--title-textContainer, .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.max-width-small .bolt-filter-dropdown-label {
  max-width: 150px;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.vss-FilterBar--item-keyword-container {
  flex-grow: 1;
  margin-right: 8px;
  min-width: 220px;
  display: flex;
  max-width: 100%;
}
@media screen and (max-width: 599px) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item.vss-FilterBar--item-keyword-container {
    min-width: 140px;
    width: 140px;
  }
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item input::-ms-clear {
  display: none;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown {
  border-radius: 2px;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown:hover {
  background: rgba(0, 0, 0, 0.06);
  background: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown .vss-PickListDropdown--title-text-withSelections {
  font-weight: 600;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-FilterBar--item-keyword input {
  /** Keyword filter has a search icon to the left which adds its own 10px of padding */
  padding: 0;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title {
  border: 0;
  background: transparent;
  padding: 6px 12px;
  overflow: visible;
  border-radius: 2px;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title .vss-PickListDropdown--title-textContainer {
  margin: 0;
  max-width: 340px;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--item .vss-PickListDropdown--title .vss-Icon {
  margin-left: 10px;
  margin-right: 0;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items {
  display: flex;
  flex-shrink: 0;
  margin-left: 8px;
}
@media screen and (max-width: 599px) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items {
    margin-left: 0px;
  }
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-clear {
  display: flex;
  justify-content: center;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-clear .filter-bar-button:not([disabled]):hover {
  background-color: transparent;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action.vss-FilterBar--action-apply {
  align-items: center;
  display: flex;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--action .filter-bar-button {
  overflow: visible;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container {
  display: flex;
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button {
  width: 32px;
  min-width: 32px;
  margin-right: 10px;
  background-color: transparent;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
@media screen and (max-width: 599px) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button {
    margin-right: 0px;
  }
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:hover:not(.disabled) {
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}
@media (forced-colors: active) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:hover:not(.disabled) {
    background: highlight;
    color: highlighttext;
  }
}
.vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
}
@media (forced-colors: active) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button.disabled {
    color: grayText;
    background: window;
  }
}
@media (forced-colors: active) {
  .vss-FilterBar .vss-FilterBar--list .vss-FilterBar--right-items .vss-FilterBar--page-button-container .vss-FilterBar-page-button:focus {
    background: highlight;
    color: highlighttext;
  }
}

.bolt-filterbar-white {
  background: rgba(255, 255, 255, 1);
  background: var(--callout-background-color,rgba(255, 255, 255, 1));
}

/*# sourceMappingURL=FilterBar.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/FilterBar/FilterBar.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/FilterBar/FilterBar.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,cAAA;EACA,+BC6Hc;ED5Hd,4DAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EEAF,gBAAgB;ACsCd;ADpCJ;EACE;IACE,4BAA4B;EAC9B;AFCE;AECJ;EFCQ,iBAAA;EECN,kBAAkB;AFCZ;AECR;EACE,6BAA6B;AFG3B;AEDJ;EFGQ,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EEDN,WAAW;AFGL;AEDR;EACE,yBAAyB;AFInB;AEFR;EFIY,cAAA;EEFV,eAAe;ADiUb;AC/TJ;EACE;IACE,gBAAgB;EAClB;AFGU;AEDZ;EACE,6BAA6B;AFInB;AEFZ;EACE,gBAAgB;AFMN;AEJZ;EFMgB,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EEJd,eAAe;AD+Sb;AC7SJ;EACE;IFKkB,gBAAA;IEHhB,YAAY;EACd;AFMU;AEJZ;EACE,aAAa;AFOH;AELZ;EACE,kBAAkB;AFOJ;AELhB;EACE,+BAA+B;EFQjB,4DAAA;AENhB;AACA;EFUY,gBAAA;AACI;AERhB;EACE,qFAAqF;EFW3E,UAAA;AETZ;AACA;EFWgB,SAAA;EACA,uBAAA;EACA,iBAAA;EETd,iBAAiB;EFWH,kBAAA;AEThB;AACA;EACE,SAAS;EFYK,gBAAA;AEVhB;AACA;EFYoB,iBC4DH;ECtEf,eAAe;EFeT,yBAAA;EACI,qDAAA;AEbZ;AACA;EACE,aAAa;EDoQX,cAAA;ED1PI,gBAAA;AEPR;AACA;EACE;IFec,gBAAA;EACI;AEbpB;AACA;EFeoB,aAAA;EACI,uBAAA;AEbxB;AFiBgB;EACI,6BAAA;AEfpB;AACA;EFkBgB,mBAAA;EACI,aAAA;AEhBpB;AFoBY;EACI,iBAAA;AElBhB;AFoBgB;EACI,aAAA;AElBpB;AACA;EFoBoB,WAAA;EACA,eCcL;EChCb,kBAAkB;EDuOhB,6BAAA;ED1NY,wBAAA;EEVd,kDFkBsB;AEjBxB;AACA;EFmBoB;IACI,iBCrBN;ECIhB;ACtFE;ADwFJ;EACE,qCFgB0B;EEf1B,kEFgB0B;AEf5B;AACA;EFkBoB;IACI,qBCOR;ICvBZ,oBAAoB;EC/FpB;ADiGJ;AACA;EACE,yBFe0B;EEd1B,oDAAoD;AACtD;ACrGI;EHsHgB;IAEQ,eAAA;IACA,kBAAA;EEf1B;AACF;AACA;EFsBA;IACI,qBCWqB;IC/BrB,oBAAoB;EACtB;AACF;;AAEA;EACE,kCAAkC;EAClC,kEAAkE;AACpE;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
